import { AnyAppEvent, AppEvent } from "../../appEvent.types";

const eventName = "validate-exponent-activity" as const;

export type ValidateExponentActivityEventData = {
  activityId: string;
};
export type ValidateExponentActivityEvent = AppEvent<
  typeof eventName,
  ValidateExponentActivityEventData
>;

export const isValidateExponentActivityEvent = (
  event: AnyAppEvent
): event is ValidateExponentActivityEvent => event.name === eventName;

export { eventName as validateExponentActivity };
